<div class="santa-w-full santa-p-40 santa-box-border santa-mx-auto" [style.maxWidth.px]="1300">
  <div class="santa-py-40 santa-flex santa-items-center santa-justify-center">
    <img [style.minWidth.px]="420" [src]="illustration" height="auto" width="420" alt="" loading="eager" />

    <div class="santa-p-40">
      <h2 class="santa-typo-h1 santa-mb-10">
        {{ translations.pageNotFound | translate }}
      </h2>

      <santa-button *ngFor="let link of LINKS; trackBy: trackByIndex" type="additional" mode="no-x-indent" [routerLink]="[link.path]">
        {{ link.label }}
      </santa-button>
    </div>
  </div>
</div>
